import { IProject } from './../../../../../apps/resource-portal/src/app/models/project';
import { BehaviorSubject } from 'rxjs';
import { IResponse } from 'apps/resource-portal/src/app/models/response';
import { Subject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { finalize, map, takeUntil } from "rxjs/operators";
import { LoadingService } from './loading.service';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: "root",
})
export class CommonService {
  selectedProject = new BehaviorSubject<any>(null);
  constructor() { }
}
